import {
    allFavouritedImagesInStorage,
    isImageFavourited,
    subscribeFavourites,
    subscribeInspirations,
} from 'helpers/store';
import {
    publish,
    UPDATE_FAVOURITES,
    UPDATE_INSPIRATIONS,
} from 'helpers/pubsub';
import initDualCurrency from './dual-currency/init';

function initPublicApi() {
    window.ikea.favourites = {
        agentLoaded: true,
        isImageFavourited,
        allFavouritedImagesInStorage,
    };
    initDualCurrency();
    /**
     * Whenever the stored data is updated, we publish a pubsub event
     */
    subscribeFavourites(d => publish(UPDATE_FAVOURITES, d));
    subscribeInspirations(d => publish(UPDATE_INSPIRATIONS, d));
}

export default initPublicApi;
